import { AutomationTriggerType } from "@/types/graphql/partner.generated";

/**
 * Группы диалога создания автоматизации. Это карта подписей (вид
 * кабинета), а не правило: какие шаблоны есть и на каком событии они
 * стоят, отдаёт сервер (automationGraphRules.templates[].trigger), здесь
 * только то, под каким заголовком шаблон показать.
 */
export type TemplateGroup =
  | "scratch"
  | "platformEvents"
  | "newViewers"
  | "purchasesAndViewing"
  | "subscriptions"
  | "other";

/** Порядок групп в диалоге. */
export const TEMPLATE_GROUPS: TemplateGroup[] = [
  "scratch",
  "platformEvents",
  "newViewers",
  "purchasesAndViewing",
  "subscriptions",
  "other",
];

export const TEMPLATE_GROUP_KEYS: Record<TemplateGroup, string> = {
  scratch: "automations.create.groups.scratch",
  platformEvents: "automations.create.groups.platformEvents",
  newViewers: "automations.create.groups.newViewers",
  purchasesAndViewing: "automations.create.groups.purchasesAndViewing",
  subscriptions: "automations.create.groups.subscriptions",
  other: "automations.create.groups.other",
};

/** Семья события триггера цепочки; событие вне карты попадает в «Другое». */
const JOURNEY_TRIGGER_GROUPS: Partial<
  Record<AutomationTriggerType, TemplateGroup>
> = {
  [AutomationTriggerType.UserRegisteredType]: "newViewers",
  [AutomationTriggerType.CheckoutStartedType]: "purchasesAndViewing",
  [AutomationTriggerType.PaymentSucceededType]: "purchasesAndViewing",
  [AutomationTriggerType.ProductPurchasedType]: "purchasesAndViewing",
  [AutomationTriggerType.ViewStartedType]: "purchasesAndViewing",
  [AutomationTriggerType.ViewCompletedType]: "purchasesAndViewing",
  [AutomationTriggerType.SubscriptionEndingType]: "subscriptions",
  [AutomationTriggerType.SubscriptionCancelledType]: "subscriptions",
  [AutomationTriggerType.SubscriptionExpiredType]: "subscriptions",
  [AutomationTriggerType.RenewalFailedType]: "subscriptions",
};

/** Группа шаблона цепочки по событию его триггера. */
export const journeyTemplateGroup = (
  trigger: AutomationTriggerType | null | undefined
): TemplateGroup =>
  (trigger ? JOURNEY_TRIGGER_GROUPS[trigger] : undefined) ?? "other";
